import cn from 'classnames';
import { Form, Layout } from 'connex-cds';
import React from 'react';
import styled from 'styled-components';
import { TicketNumber } from './TicketNumber';
import { TimeStamp } from './TimeStamp';
import styleMobile from './styleMobile';

const { Container } = Layout;

const Styled = styled(Container)`
  ${styleMobile}
`;

export const SignatureContainerMobile = () => {
  const {
    Components: { Signature },
  } = Form.useFormContext();

  return (
    <Styled className={cn('signature-section')}>
      <Signature />
      <div className="caption">
        <TicketNumber />
        <TimeStamp />
      </div>
    </Styled>
  );
};
